import { datadogRum } from '@datadog/browser-rum';

export function reportError(errorCode: string, error: Error, context?: Record<string, unknown>): void {
	datadogRum.addError(error, { ...context, errorCode });
}
